<template>
  <v-app class="page">
    <Header
      :headTitle="headTitle"
      :isShowBackBtn="isShowBackBtn"
      :isShowLoginBtn="true"
      @clickHamburger="userInfo"
      @clickLogOut="logout"
      @clickLogIn="logIn"
      @clickBack="clickBack"
    />

    <component :class="{ test: isTest }" :is="getThemeMode.layout" />

    <!-- userDrawer -->
    <v-navigation-drawer
      v-model="userDrawer"
      fixed
      right
      height="100%"
      temporary
      floating
      width="70%"
    >
      <user-drawer
        :PropsAccessInfo="accessInfo"
        @closeDrawer="userDrawer = false"
        @clickHome="clickHome"
        @clickChangeUserInfo="clickChangeUserInfo"
        @clickMoveMenu="clickMoveMenu"
      >
        <template v-slot:userDrawerCloseButton>
          <v-btn icon color @click.stop="userDrawer = !userDrawer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </user-drawer>

      <template v-slot:append>
        <div class="my-4 mx-4">
          <base-hover-button
            text="로그아웃"
            color="primary"
            x-large
            depressed
            block
            @click.native="logout"
          />
        </div>
      </template>
    </v-navigation-drawer>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "./commonComp/WS-Header.vue";
import Cookies from "js-cookie";
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    Header,
    ConfirmDialog,
    UserDrawer: () => import("@/components/common-drawer/UserDrawer.vue"),
  },
  data() {
    return {
      isTest: false,
      layoutName: "",
      userDrawer: false,
      headTitle: "지피테라퓨틱스 OTC 정보관",
      isShowBackBtn: false,
      moveTarget: "",
    };
  },
  computed: {
    accessInfo() {
      if (!this.isAuthorized) return;
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized", "getThemeMode"]),
  },
  mounted() {
    // 리로드 처리
    if (this.$route.fullPath === "/home") {
      this.isShowBackBtn = false;
      this.headTitle = "HOME";
    }
    if (this.$route.fullPath === "/intro") {
      this.isShowBackBtn = true;
      this.headTitle = "지피테라퓨틱스 소개";
    }
    if (this.$route.fullPath === "/actinum") {
      this.isShowBackBtn = true;
      this.headTitle = "액티넘 정보";
    }
    if (this.$route.fullPath === "/lamisil") {
      this.isShowBackBtn = true;
      this.headTitle = "라마실 정보";
    }
    if (this.$route.fullPath === "/betadine") {
      this.isShowBackBtn = true;
      this.headTitle = "베타딘 정보";
    }
    if (this.$route.fullPath === "/cyclogest") {
      this.isShowBackBtn = true;
      this.headTitle = "사이클로제스트 정보";
    }
    if (this.$route.fullPath === "/mr-visit") {
      this.isShowBackBtn = true;
      this.headTitle = "MR 방문접수";
    }
    if (this.$route.fullPath === "/tempChangePassword") {
      this.headTitle = "비밀번호 변경";
    }

    if (this.$route.fullPath === "/userInfo") this.clickChangeUserInfo();
    if (this.$route.fullPath === "/changePassword") this.clickChangePassword();
  },
  watch: {
    $route(to) {
      if (this.$route.fullPath === "/home") {
        this.isShowBackBtn = false;
        this.headTitle = "HOME";
      }
      if (this.$route.fullPath === "/intro") {
        this.isShowBackBtn = true;
        this.headTitle = "지피테라퓨틱스 소개";
      }
      if (this.$route.fullPath === "/actinum") {
        this.isShowBackBtn = true;
        this.headTitle = "액티넘 정보";
      }
      if (this.$route.fullPath === "/lamisil") {
        this.isShowBackBtn = true;
        this.headTitle = "라미실 정보";
      }
      if (this.$route.fullPath === "/betadine") {
        this.isShowBackBtn = true;
        this.headTitle = "베타딘 정보";
      }
      if (this.$route.fullPath === "/cyclogest") {
        this.isShowBackBtn = true;
        this.headTitle = "사이클로제스트 정보";
      }
      if (this.$route.fullPath === "/mr-visit") {
        this.isShowBackBtn = true;
        this.headTitle = "MR 방문접수";
      }
      if (this.$route.fullPath === "/tempChangePassword") {
        this.headTitle = "비밀번호 변경";
      }
    },
  },
  methods: {
    userInfo() {
      this.userDrawer = !this.userDrawer;
    },
    logIn() {
      this.gotoPage("/login");
    },
    logout() {
      this.signOut().then(() => {
        this.gotoPage("/login");
      });
    },
    clickHome() {
      this.moveTarget = "홈";
      if (this.headTitle === "내 정보 관리") {
        this.$refs.refConfirmDialog.open(
          "개인정보 변경을 중단하고 이동하시겠습니까?"
        );
        return;
      }
      if (this.headTitle === "비밀번호변경") {
        this.$refs.refConfirmDialog.open(
          "비밀번호 변경을 중단하고 이동하시겠습니까?"
        );
        return;
      }
      this.headTitle = "지피테라퓨틱스 OTC 정보관";

      this.gotoPage("/home");
    },
    clickChangeUserInfo() {
      this.moveTarget = "내 정보 관리";
      if (this.headTitle === "비밀번호변경") {
        this.$refs.refConfirmDialog.open(
          "비밀번호 변경을 중단하고 이동하시겠습니까?"
        );
        return;
      }
      this.headTitle = "내 정보 관리";
      this.isShowBackBtn = true;
      this.gotoPage("/userInfo");
    },
    clickChangePassword() {
      this.moveTarget = "비밀번호 변경";
      this.headTitle = "내 정보 관리";
      this.isShowBackBtn = true;
      this.gotoPage("/changePassword");
    },
    clickMoveMenu(menu) {
      this.moveTarget = "내 정보 관리";
      if (this.headTitle === "비밀번호변경") {
        this.$refs.refConfirmDialog.open(
          "비밀번호 변경을 중단하고 이동하시겠습니까?"
        );
        return;
      }
      this.headTitle = "내 정보 관리";
      this.isShowBackBtn = true;
      this.gotoPage("/"+menu);
    },
    clickPopupConfirm() {
      switch (this.moveTarget) {
        case "홈":
          this.headTitle = "홈";
          this.isShowBackBtn = false;
          this.gotoPage("/home");
          break;
        case "내 정보 관리":
          this.headTitle = "내 정보 관리";
          this.isShowBackBtn = true;
          this.gotoPage("/userInfo");
          break;
        case "비밀번호변경":
          this.headTitle = "비밀번호변경";
          this.isShowBackBtn = true;
          this.gotoPage("/changePassword");
          break;
      }
    },

    clickBack() {
      this.gotoPage("/home");
      // this.$router.go(-1);
    },
    gotoPage(page) {
      if (page === "/") {
        this.headTitle = "지피테라퓨틱스 OTC 정보관";
        this.isShowBackBtn = false;
      }
      this.$router.push({ path: page }).catch(() => {});
    },
    ...mapActions(["signOut", "changeThemeLayout"]),
  },
};
</script>
